import React from "react";
import { ArrowUpRight, Menu } from "lucide-react";
import logo from "../assets/jalsa-logo.jpeg";

function Navbar({ scrolled, scrollTo, setReserveOpen, setMenuOpen }) {
  return (
    <header className={`nav ${scrolled ? "nav-scrolled" : ""}`}>
      <button className="brand" onClick={() => scrollTo("home")} aria-label="Jalsa home">
        <img src={logo} alt="Jalsa logo" />
      </button>

      <nav className="desktop-nav">
        <button onClick={() => scrollTo("story")}>Story</button>
        <button onClick={() => scrollTo("menu")}>Menu</button>
        <button onClick={() => scrollTo("experience")}>Experience</button>
        <button onClick={() => scrollTo("events")}>Events</button>
        <button onClick={() => scrollTo("contact")}>Contact</button>
      </nav>

      <div className="nav-actions">
        <button className="gold-btn" onClick={() => setReserveOpen(true)} style={{ marginRight: "12px" }}>
          Reserve
          <ArrowUpRight size={16} />
        </button>
        <button className="hamburger" onClick={() => setMenuOpen(true)} aria-label="Open menu">
          <Menu />
        </button>
      </div>
    </header>
  );
}

export default Navbar;
